import { BarLoader } from 'react-spinners';
import { useColors } from '@/hooks/useColors';

export interface LoadingProps {}

const Loading = ({}: LoadingProps) => {
    const { primaryColor } = useColors();

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <BarLoader width={'100%'} color={primaryColor} />
        </div>
    );
};
export default Loading;
